import { render, staticRenderFns } from "./VideoPresentation.vue?vue&type=template&id=7496c116&scoped=true&"
var script = {}
import style0 from "./VideoPresentation.vue?vue&type=style&index=0&id=7496c116&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7496c116",
  null
  
)

export default component.exports